/* eslint-disable react/jsx-key */
import Box from '@mui/material/Box'
import { GridColDef } from '@mui/x-data-grid'
import {
  Button,
  Table,
  TableProvider,
  TextField,
  useTableContext
} from 'components'
import { PageContent } from 'layout'
import { useLayoutContext } from 'layout/layout.context'
import { useLoadCustomers } from 'modules/customers/hooks'
import { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { phoneMask, useDebounce } from 'utils'
import { generateGmapsURL } from 'utils/formats/mapsURL'
import { FilterListCustomer } from './components/Filter'
import {
  CustomerListProvider,
  useCustomerListContext
} from './context/customerList.context'
import { HiPlus } from 'react-icons/hi'

const columns: GridColDef[] = [
  {
    field: 'customerId',
    headerName: 'Código',
    width: 100,
    renderCell: (row) => {
      return (
        <Link
          style={{
            textDecoration: 'none',
            color: '#0C95EB'
          }}
          to={`/customers/${row.id}/details`}
        >
          <div style={{ fontWeight: 500 }}>{row.value}</div>
        </Link>
      )
    }
  },
  {
    field: 'fullname',
    headerName: 'Nome',
    flex: 1,
    minWidth: 300
  },
  {
    field: 'representant',
    headerName: 'Vendedor',
    minWidth: 100
  },
  {
    field: 'phone',
    headerName: 'Telefone',
    width: 160,
    renderCell: (row) => {
      return (
        <a
          style={{ color: '#0C95EB', textDecoration: 'none' }}
          href={`tel:${row?.row?.contact?.phone}`}
          target="_blank"
          rel="noreferrer"
        >
          {phoneMask(row?.row?.contact?.phone)}
        </a>
      )
    }
  },
  {
    field: 'address',
    headerName: 'Cidade / UF',
    width: 200,
    renderCell: (row: any) => {
      return (
        <a
          style={{ color: '#0C95EB', textDecoration: 'none' }}
          href={`https://www.google.com/maps/search/${generateGmapsURL(
            row.row.address
          )}`}
          target="_blank"
          rel="noreferrer"
        >
          {row.row.address.city} / {row.row.address.uf}
        </a>
      )
    }
  }
]

export const CustomerTable = () => {
  const [search, setSearch] = useState('')
  const { filters } = useCustomerListContext()
  const { pagination, setPagination } = useTableContext()
  const navigate = useNavigate()
  const { setBreadcrumbs } = useLayoutContext()

  useEffect(() => {
    setBreadcrumbs([{ label: 'Início', to: '/home' }, { label: 'Clientes' }])
    return () => setBreadcrumbs([])
  }, [])

  const searchDebounced = useDebounce(search, 250)

  const {
    data: customers,
    isLoading: customersLoading,
    isFetching: customersFetching
  } = useLoadCustomers({
    ...pagination,
    page: (pagination.page || 0) + 1,
    ...filters,
    search: searchDebounced
  })

  const handleSearch = (event: any) => {
    setSearch(event.target.value.toUpperCase())
    setPagination({ page: 0 })
  }

  return (
    <>
      <PageContent>
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: 16,
            flexWrap: 'wrap',
            justifyContent: 'space-between'
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '100%',
              maxWidth: 520,
              gap: 16,
              flex: 1,
              minWidth: 260
            }}
          >
            <TextField
              placeholder="Pesquisar ..."
              style={{ width: '100%', maxWidth: 400 }}
              onChange={handleSearch}
              value={search}
              type="search"
            />
            <div>
              <FilterListCustomer />
            </div>
          </div>
          <Button
            sx={{
              display: { md: 'flex', sm: 'none', xs: 'none' }
            }}
            startIcon={<HiPlus size={18} />}
            onClick={() => navigate('/customers/create')}
          >
            Novo Cliente
          </Button>
        </div>
        <div style={{ marginTop: '1rem', height: 'calc(100vh - 152px)' }}>
          <Table
            rowCount={customers?.meta.query.totalItems}
            getRowId={(row: any) => row.customerId}
            columns={columns}
            rows={customers?.data || []}
            loading={customersLoading || customersFetching}
          />
        </div>
      </PageContent>
    </>
  )
}

export const CustomerListPage = () => (
  <CustomerListProvider>
    <TableProvider>
      <CustomerTable />
    </TableProvider>
  </CustomerListProvider>
)

export default CustomerListPage
